import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SharedModule} from '../../shared/shared.module';
import {MatDividerModule} from '@angular/material/divider';
import {MatDialogModule} from '@angular/material/dialog';
import { AutomaticLogoutPopupComponent } from './automatic-logout-popup.component';
import {IconsModule} from '../../icons/icons.module';


@NgModule({
  declarations: [AutomaticLogoutPopupComponent],
  imports: [
    CommonModule,
    SharedModule,
    MatDividerModule,
    MatDialogModule,
    IconsModule
  ],
  exports: [AutomaticLogoutPopupComponent],

})
export class AutomaticLogoutPopupModule { }